import styled, { css } from 'styled-components';
import { Box } from '../Box/Box.es.js';
var Item = styled(Box).withConfig({
  componentId: "sc-17buqr7-0"
})(["flex:0 0 auto;display:flex;align-items:center;"]);
Item.displayName = "Level.Item";
var Center = styled(Box).withConfig({
  componentId: "sc-17buqr7-1"
})(["display:flex;align-items:center;justify-content:center;grid-area:center;"]);
Center.displayName = "Level.Center";
var Left = styled(Box).withConfig({
  componentId: "sc-17buqr7-2"
})(["display:flex;align-items:center;justify-content:flex-start;grid-area:left;"]);
Left.displayName = "Level.Left";
var Right = styled(Box).withConfig({
  componentId: "sc-17buqr7-3"
})(["display:flex;align-items:center;justify-content:flex-end;grid-area:right;"]);
Right.displayName = "Level.Right";
var Level = styled(Box).withConfig({
  componentId: "sc-17buqr7-4"
})(["width:100%;", ""], function (_ref) {
  var pinCenter = _ref.pinCenter,
      align = _ref.align;
  return pinCenter ? css(["display:grid;grid-template-columns:1fr auto 1fr;grid-template-areas:'left center right';column-gap:2rem;"]) : css(["display:flex;justify-content:space-between;align-items:", ";"], align);
});
export { Center, Item, Left, Level, Right };